// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"535":"b4aa2a2eb8b405bf","945":"46950272453c14d5"}[chunkId] + ".js";
};